import { render } from "./SlugField.vue?vue&type=template&id=363ae52a"
import script from "./SlugField.vue?vue&type=script&lang=js"
export * from "./SlugField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thuanluu/code/owlx/more9_venues/package/private/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SlugField.vue"]])

export default __exports__